export default __webpack_public_path__ + "static/media/sort-dsc2.ed891f48.svg";